<template>
  <span>
    <span class="cod">{{ code }}</span>{{ value }}
  </span>
</template>

<script>
export default {
  name: "MarcSubfield",
  computed: {
    code: function() {
      return Object.keys(this.subfield)[0];
    },
    value: function() {
      return Object.values(this.subfield)[0];
    }
  },
  props: {
    subfield: Object
  }
}
</script>

<style scoped>
.cod::before {
  font-weight: bold;
  content: "\2021";
}
.cod {
  font-weight: bold;
  padding-right: 0.2em;
}
</style>
